import { AppName } from './typings';

const getAppName = (currentPath: string): AppName => {
  if (currentPath === '/dashboard') {
    return 'noodle-app';
  }
  return 'other-app';
};

export default getAppName;